import Loading from '../../../../Dashboards/Common/Loading';
import { CompareCharts } from './CompareCharts';
import { Indicators } from './Indicators';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div className="side-by-side-group-increase">
            <Indicators />
            <div className="right-group-increase">
                <CompareCharts />
            </div>
        </div>
    );
};
